import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';

import { type Price as PriceType } from '../../../shared/types';
import { formatPrice } from '../../helper/formatPrice';
import styles from './Price.module.scss';

type FriendsDiscountInfoProps = {
    readonly price: PriceType;
    readonly multiplier: number;
};

const FriendsDiscountInfo = ({ multiplier, price }: FriendsDiscountInfoProps): JSX.Element => {
    const intl = useIntl();

    const priceGrossAmount = Number(price.gross.amount);
    const calculatedDiscount =
        priceGrossAmount * multiplier -
        (priceGrossAmount + priceGrossAmount * 0.9 * (multiplier - 1));

    return (
        <div className={classNames('pt-0 pt-sm-1x', styles.discountInfo)}>
            <FormattedMessage
                defaultMessage="Du sparst {friendsDiscount}. Dein Rabattcode FRIENDS wird automatisch im Warenkorb abgezogen."
                values={{
                    friendsDiscount: (
                        <strong>
                            {formatPrice(intl.locale, calculatedDiscount, price.gross.currencyCode)}
                        </strong>
                    ),
                }}
            />
        </div>
    );
};

export { FriendsDiscountInfo };
